var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"live mt-1",attrs:{"id":"live"}},[_c('b-row',{staticClass:"m-0 text-center instance"},[_c('b-col',{staticClass:"p-0"},[_c('div',{staticClass:"img-cover"}),_c('div',{attrs:{"id":"player_live"}})])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }